(function () {
  var CHARS = '!<>-_\\/[]{}=+*^?#$%01234567890';

  // Product names and nav scramble. Section headings stay static.
  var SELECTOR = [
    '.product__title h1',
    '.product__title h2',
    '.header__inline-menu .scramble-menu-item',
    '.menu-drawer__menu-item',
    '.pg-name',
    '.nr-name',
    '.mp-name',
    '.card__heading a',
    '.card-information .card__heading'
  ].join(', ');

  var textCache = new WeakMap();

  function TextScramble(el) {
    this.el = el;
    this.frame = 0;
    this.queue = [];
    this.frameRequest = null;
    this.resolve = null;
    this.update = this.update.bind(this);
  }

  TextScramble.prototype.setText = function (newText) {
    var oldText = this.el.textContent;
    var length = Math.max(oldText.length, newText.length);
    var self = this;
    var promise = new Promise(function (resolve) {
      self.resolve = resolve;
    });
    this.queue = [];
    for (var i = 0; i < length; i++) {
      var from = oldText[i] || '';
      var to = newText[i] || '';
      var start = Math.round(i * 1.2) + Math.floor(Math.random() * 6);
      var end = start + 10 + Math.floor(Math.random() * 8);
      this.queue.push({ from: from, to: to, start: start, end: end, char: null });
    }
    if (this.frameRequest) {
      cancelAnimationFrame(this.frameRequest);
    }
    this.frame = 0;
    this.update();
    return promise;
  };

  TextScramble.prototype.update = function () {
    var output = '';
    var complete = 0;
    for (var i = 0; i < this.queue.length; i++) {
      var item = this.queue[i];
      if (this.frame >= item.end) {
        complete++;
        output += item.to;
      } else if (this.frame >= item.start) {
        if (!item.char || this.frame % 3 === 0) {
          item.char = CHARS[Math.floor(Math.random() * CHARS.length)];
        }
        output += '<span class="scramble-dud">' + item.char + '</span>';
      } else {
        output += item.from;
      }
    }
    this.el.innerHTML = output;
    if (complete === this.queue.length) {
      var finalText = textCache.get(this.el);
      if (finalText) {
        this.el.textContent = finalText;
      }
      this.resolve();
    } else {
      this.frameRequest = requestAnimationFrame(this.update);
      this.frame++;
    }
  };

  function scramble(el, force) {
    if (!force && el.dataset.scrambled === 'true') return;
    if (el.querySelector('img, svg')) return;
    var finalText = (textCache.get(el) || el.textContent).replace(/\s+/g, ' ').trim();
    if (!finalText) return;
    el.dataset.scrambled = 'true';
    textCache.set(el, finalText);
    new TextScramble(el).setText(finalText);
  }

  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                scramble(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px' }
        )
      : null;

  function initScramble(root) {
    var scope = root || document;
    var targets = scope.querySelectorAll(SELECTOR);
    targets.forEach(function (el) {
      if (el.dataset.scrambleQueued === 'true') return;
      el.dataset.scrambleQueued = 'true';
      if (observer) {
        observer.observe(el);
      } else {
        scramble(el);
      }
    });
  }

  function replayDrawer() {
    document.querySelectorAll('.menu-drawer__menu-item').forEach(function (el) {
      scramble(el, true);
    });
  }

  function watchDrawer() {
    var drawer = document.getElementById('Details-menu-drawer-container');
    if (!drawer) return;
    var summary = drawer.querySelector('summary');
    if (!summary || summary.dataset.scrambleBound === 'true') return;
    summary.dataset.scrambleBound = 'true';
    summary.addEventListener('click', function () {
      if (!drawer.hasAttribute('open')) {
        setTimeout(replayDrawer, 30);
      }
    });
  }

  function boot() {
    initScramble(document);
    watchDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initScramble(event.target);
    watchDrawer();
  });
})();
